import * as z from "zod/v4";

const BalanceTransactionDataSchema_ = z.object({
  date: z.date(),
  amount: z.string(),
  orderNames: z.array(z.string()).nullish(),
  batchName: z.string().nullish(),
  description: z.string(),
  justification: z.string().nullish(),
  balanceSnapshot: z.string().nullish(),
  transactionType: z.string().nullish(),
  fulfillmentGroupId: z.string().nullish(),
});

export const BalanceTransactionDataSchema: z.ZodType<BalanceTransactionData> =
  BalanceTransactionDataSchema_;
export interface BalanceTransactionData
  extends z.infer<typeof BalanceTransactionDataSchema_> {}
